import { Component } from '@angular/core';

@Component({
  selector: 'app-about-main',
  templateUrl: './about-main.component.html'
})
export class AboutMainComponent {
}
